import { ChatItemSearchContainerProps } from './chatSearchProps';
import { ChatItemSearchController, ChatItemSearchLoader } from './chatSearchInterface';
import { ReportingShellContainerBaseConfig } from '../../../../base';

export function createChatItemSearchContainer(
    config: ReportingShellContainerBaseConfig,
    loader: ChatItemSearchLoader,
    controller: ChatItemSearchController
): React.FC<ChatItemSearchContainerProps> {
    const {
        repository: { research: repository },
        context: { useContext },
        pubsub: { router: pubsub },
    } = config;

    return ({ as: View, item, ...containerProps }) => {
        const context = useContext();
        const data = loader.useLoad(context, { item });
        const props = controller.useProps(context, data, {});
        return <View {...props} />;
    };
}
